export const splitString = (value) => value.match(/[A-Z][a-z]+|[0-9]+/g).join(' ');
export const binderLimits = 'binderLimits';
